import { createSlice } from '@reduxjs/toolkit';
import { resetAllSlices } from '../../../../Providers/mainStore.slice';

const initialState = {
  setupDialogOpen: false,
  disableDialogOpen: false,
  setupConfig: null,
};

const authenticatorAppSlice = createSlice({
  name: 'authenticatorApp',
  initialState,
  reducers: {
    setAuthenticatorAppState: (state, action) => {
      return { ...state, ...action.payload };
    },
    resetAuthenticatorAppState: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetAllSlices, () => {
      return initialState;
    });
  },
});

export const { setAuthenticatorAppState, resetAuthenticatorAppState } =
  authenticatorAppSlice.actions;

export default authenticatorAppSlice.reducer;
